import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { isDesktop } from 'react-device-detect'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
import { useRiskRelatedForms } from 'hooks/risks'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE, IconButton } from 'components/UI'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
// static
import ArrowIcon from '@mui/icons-material/ArrowBack'
import EditIcon from '@mui/icons-material/Edit'

const RelatedFormButtons: React.FC = () => {
  const router = useRouter()

  const { risk } = React.useContext(RiskAPIContext)

  const { parentRelatedForm: relatedForm } = useRiskRelatedForms()

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  const onEditClick = () => window.open(`/forms/templates/edit/${risk.riskTemplate.id}`, '_blank')

  const onBackClick = () => {
    router.push({
      pathname: `/forms/edit/template/${risk.riskTemplate.id}`,
      query: {
        multiple: 'true',
        parentRiskId: risk.parentRiskId,
        parentTemplateId: risk.parentRisk.riskTemplate.id,
        ...(!!risk.recurrence && { scheduled: 'true' })
      }
    })
  }

  if (!relatedForm) {
    return null
  }

  return (
    <>
      {relatedForm.multiple &&
        (isDesktop ? (
          <Button
            onClick={onBackClick}
            style={CREATE_BUTTON_STYLE}
            layout={BUTTON_LAYOUTS.PURPLE}
            disabled={!relatedForm?.permissions.riskCreate && !relatedForm?.permissions.riskModify}>
            Back
          </Button>
        ) : (
          <IconButton onClick={onBackClick}>
            <ArrowIcon />
          </IconButton>
        ))}
      {isDesktop ? (
        <Button
          onClick={onEditClick}
          style={CREATE_BUTTON_STYLE}
          disabled={!manageRiskTemplates}
          layout={BUTTON_LAYOUTS.DARK_BLUE}>
          Edit template
        </Button>
      ) : (
        <IconButton onClick={onEditClick}>
          <EditIcon />
        </IconButton>
      )}
    </>
  )
}

export default RelatedFormButtons
